// extracted by mini-css-extract-plugin
export var modal = "_td-0";
export var table = "_td-1";